import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/speaker-off.svg'
import _imports_1 from '@/assets/icons/svg/speaker.svg'


const _withScopeId = n => (_pushScopeId("data-v-4852c8f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-col justify-evenly w-full h-full sl-intro-background text-center text-white" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-6 left-12 z-50"
}
const _hoisted_3 = { class: "relative flex flex-row items-center" }
const _hoisted_4 = {
  class: "rounded-l-full p-3 text-center flex flex-col justify-center h-12 -m-6 -mt-4 pl-6 pr-8",
  style: {"background-color":"#48b6ff"}
}
const _hoisted_5 = { class: "uppercase font-bold" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute w-full h-24 top-0 z-30 sl-intro-background" }, null, -1 /* HOISTED */))
const _hoisted_8 = { class: "absolute w-full h-full top-0 left-0 z-40 flex flex-col place-items-center justify-center" }
const _hoisted_9 = { class: "mt-16" }
const _hoisted_10 = { class: "relative inline-block p-6" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_0,
  alt: "close"
}
const _hoisted_13 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_1,
  alt: "close"
}
const _hoisted_14 = {
  key: 0,
  class: "mt-12 text-5xl font-bold"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-3 text-xl font-bold"
}
const _hoisted_16 = { class: "flex flex-row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Omar's lightbub placement for Word Focus mode "),
    ($props.discussion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString($setup.t($props.discussion)), 1 /* TEXT */)
            ]),
            _createElementVNode("img", {
              src: $setup.omarChat,
              class: "z-10 w-16",
              alt: "Discussion Time icon"
            }, null, 8 /* PROPS */, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            class: "h-56 p-3",
            style: _normalizeStyle({ height: $props.imageHeight }),
            src: $props.image ? $props.image : $setup.omarGlad,
            alt: "instructions - happy omar image"
          }, null, 12 /* STYLE, PROPS */, _hoisted_11),
          _renderSlot(_ctx.$slots, "pagination", {}, undefined, true),
          _createVNode($setup["Button"], {
            class: "absolute pointer-events-auto bg-white p-2 rounded-full",
            style: _normalizeStyle([{ top: $props.speakerTop, right: $props.speakerRight }]),
            childclass: 'w-12 h-12',
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.soundIsPlaying ? $setup.stopSounds() : _ctx.$emit('playsound')))
          }, {
            default: _withCtx(() => [
              ($setup.soundIsPlaying)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : (_openBlock(), _createElementBlock("img", _hoisted_13))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["style"])
        ]),
        ($props.title)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($props.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($props.description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Get started button goes here"),
      _createElementVNode("div", _hoisted_16, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}